document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.logo-slider-carousel');
  if (!container) return;

  const defaultSlides = 4;

  const swiper = new Swiper('.logo-slider-carousel', {
    slidesPerView: defaultSlides,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      576: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
      1200: { slidesPerView: defaultSlides },
    },
    on: {
      init: function () {
        showCarousel();
      },
      resize: function () {
        this.update();
        showCarousel();
      },
      slideChangeTransitionEnd: function () {
        this.update();
      }
    }
  });

  function showCarousel() {
    if (!container) return;
    container.style.visibility = 'visible';
    container.style.opacity = '1';
  }

  const imgs = container.querySelectorAll('img');
  let loadedCount = 0;
  if (imgs.length > 0) {
    imgs.forEach(img => {
      if (img.complete) {
        loadedCount++;
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === imgs.length) swiper.update();
        });
        img.addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === imgs.length) swiper.update();
        });
      }
    });
    if (loadedCount === imgs.length) swiper.update();
  } else {
    swiper.update();
  }
});
